import styled from 'styled-components';

import { device } from 'styles/breakpoints';

export const AuthLayoutWrapper = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.blue};
  overflow-x: hidden;

  .auth-header {
    display: flex;
    justify-content: center;
    > div {
      transition: all 0.3s ease;
      margin: 40px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-logo {
      display: flex !important;
    }
    &-logo-mobile {
      display: none !important;
    }
    &-actions {
      display: flex;
      align-items: center;
      > p {
        color: ${({ theme }) => theme.colors.white};
      }
      &-link {
        margin-left: 25px;
        width: 120px;
        height: 50px;
        background-color: ${({ theme }) => theme.colors.white};
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  @media ${device.tablet} {
    .auth-header {
      > div {
        margin: 20px 10px;
      }
      &-logo {
        display: none !important;
      }
      &-logo-mobile {
        display: flex !important;
      }
      &-actions {
        > p {
          display: none;
        }
      }
    }
  }
`;

export const AuthContent = styled.div`
  width: 100%;
  max-width: 605px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 60px 25px;
  margin: 0 auto;
  margin-bottom: 50px;
  transition: all 0.3s ease;

  @media ${device.tablet} {
    max-width: 100%;
    padding: 48px 32px;
    min-height: calc(100vh - 65px);
    margin-bottom: 0;
  }
`;
